import { combineReducers } from 'redux';
import ParticipationMatchesGridCreate from './ParticipationMatchesGrid/ParticipationMatchesGridCreate';

import {
  GET_PARTICIPATION_MATCHES_START,
  GET_PARTICIPATION_MATCHES_SUCCESS,
  GET_PARTICIPATION_MATCHES_ERROR,
  RESET_PARTICIPATION_MATCHES
} from './ParticipationMatchesActions';

const initialState = {
  surveyJobs: {
    jobs: [],
    loading: false,
    loaded: false,
    status: null,
    error: null
  }
};

function participationMatchesReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_PARTICIPATION_MATCHES_START: {
      return {
        ...state,
        surveyJobs: {
          jobs: state.surveyJobs?.jobs,
          loading: true,
          loaded: false,
          status: null,
          error: null
        }
      };
    }
    case GET_PARTICIPATION_MATCHES_SUCCESS: {
      return {
        ...state,
        surveyJobs: {
          jobs: action.participationMatches,
          loading: false,
          loaded: true,
          status: action.status,
          error: null
        }
      };
    }
    case GET_PARTICIPATION_MATCHES_ERROR: {
      return {
        ...state,
        surveyJobs: {
          jobs: [],
          loading: false,
          loaded: true,
          status: action.status,
          error: action.message
        }
      };
    }
    case RESET_PARTICIPATION_MATCHES: {
      return {
        ...initialState
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
}

export default combineReducers({
  participationMatchesReducer,
  participationMatchesGridReducer: ParticipationMatchesGridCreate
});
